window.addEventListener("load", () => {
  if (typeof AOS !== "undefined" && AOS && typeof AOS.init === "function") {
    AOS.init({});
  }
});

(() => {
  "use strict";

  /**
   * Przycisk zamknięcia (X) wewnątrz panelu menu.
   * Hamburger w nagłówku nie wystarcza: po otwarciu menu blokujemy scroll
   * (overflow: hidden na html), co wyłącza position: sticky nagłówka – na
   * przewiniętej stronie nagłówek (a z nim X) wyjeżdża poza ekran.
   * Panel jest position: fixed, więc jego własny X jest widoczny zawsze.
   */
  const createMobileCloseButton = () => {
    const button = document.createElement("button");
    button.type = "button";
    button.className = "site-header__mobile-close";
    button.setAttribute("aria-label", "Zamknij menu");
    button.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true" focusable="false">' +
      '<line x1="6" y1="6" x2="18" y2="18"></line>' +
      '<line x1="18" y1="6" x2="6" y2="18"></line>' +
      "</svg>";
    return button;
  };

  const createMobileMenu = (nav, header) => {
    const mobileMenu = document.createElement("div");
    mobileMenu.className = "site-header__mobile-menu";

    mobileMenu.appendChild(createMobileCloseButton());
    // Klasa informuje CSS, że panel ma własny X – wtedy hamburger w nagłówku
    // jest ukrywany, żeby nie było dwóch krzyżyków naraz.
    header.classList.add("has-mobile-close");

    const navClone = nav.cloneNode(true);
    navClone.className = "site-header__nav";
    mobileMenu.appendChild(navClone);

    const cta = header.querySelector(".site-header__cta");
    if (cta) {
      const ctaClone = cta.cloneNode(true);
      mobileMenu.appendChild(ctaClone);
    }

    const headerMain = header.querySelector(".site-header__main");
    if (headerMain) {
      headerMain.appendChild(mobileMenu);
    }

    return mobileMenu;
  };

  const handleMobileSubmenus = (mobileMenu) => {
    const parentItems = mobileMenu.querySelectorAll(
      ".has-children, .menu-item-has-children",
    );

    parentItems.forEach((item) => {
      const link = item.querySelector("a");
      const submenu = item.querySelector(".sub-menu");

      if (!link || !submenu) return;

      const toggle = document.createElement("button");
      toggle.className = "submenu-toggle";
      toggle.setAttribute("aria-expanded", "false");
      toggle.setAttribute("aria-label", "Toggle submenu");
      toggle.innerHTML = '<span class="submenu-toggle-icon">+</span>';

      if (link.parentNode) {
        link.parentNode.insertBefore(toggle, link.nextSibling);
      }

      toggle.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        const isExpanded = toggle.getAttribute("aria-expanded") === "true";

        mobileMenu.querySelectorAll(".submenu-toggle").forEach((otherToggle) => {
          if (otherToggle === toggle) return;

          otherToggle.setAttribute("aria-expanded", "false");

          const otherSubmenu = otherToggle.parentNode
            ? otherToggle.parentNode.querySelector(".sub-menu")
            : null;
          if (otherSubmenu) otherSubmenu.classList.remove("is-open");

          const otherIcon = otherToggle.querySelector(".submenu-toggle-icon");
          if (otherIcon) otherIcon.textContent = "+";
        });

        toggle.setAttribute("aria-expanded", String(!isExpanded));
        submenu.classList.toggle("is-open");

        const icon = toggle.querySelector(".submenu-toggle-icon");
        if (icon) icon.textContent = !isExpanded ? "−" : "+";
      });
    });
  };

  /**
   * Close mobile menu helper
   */
  const closeMobileMenu = (mobileToggle, mobileMenu, header) => {
    const focusWasInsideMenu = mobileMenu.contains(document.activeElement);

    mobileToggle.setAttribute("aria-expanded", "false");
    mobileMenu.classList.remove("is-open");
    header.classList.remove("is-open");
    document.body.style.overflow = "";
    document.documentElement.style.overflow = "";

    // Po zamknięciu z wnętrza menu wracamy fokusem na hamburgera
    if (focusWasInsideMenu) {
      mobileToggle.focus({ preventScroll: true });
    }
  };

  /**
   * Handle anchor links
   * - Jeśli id istnieje na bieżącej stronie → płynny scroll
   * - Jeśli id nie istnieje → przekierowanie na stronę główną z /#id (przeglądarka obsłuży scroll)
   * - Linki bez # (np. /faq) → normalna nawigacja, bez preventDefault
   * - Na mobile zawsze zamyka menu przed akcją
   */
  const handleAnchorLinks = (mobileToggle, mobileMenu, header) => {
    document.addEventListener("click", (e) => {
      const link = e.target.closest('a[href^="#"], a[href*="/#"]');
      if (!link) return;

      const href = link.getAttribute("href");

      // Wyciągnij targetId
      const targetId = href.includes("/#")
        ? href.split("/#")[1]
        : href.slice(1);

      // Brak id (np. href="#") - nic nie rób
      if (!targetId) {
        e.preventDefault();
        return;
      }

      const target = document.getElementById(targetId);

      if (target) {
        // Id istnieje na tej stronie - płynny scroll
        e.preventDefault();

        if (mobileMenu.classList.contains("is-open")) {
          closeMobileMenu(mobileToggle, mobileMenu, header);
        }

        setTimeout(() => {
          target.scrollIntoView({ behavior: "smooth" });
        }, 300);
      } else {
        // Id nie istnieje na tej stronie - przekieruj na stronę główną z #id
        // Nie robimy preventDefault - pozwalamy przeglądarce nawigować
        // Ale najpierw zamykamy menu
        if (mobileMenu.classList.contains("is-open")) {
          closeMobileMenu(mobileToggle, mobileMenu, header);
        }

        // Ustaw href na format /#id i pozwól przeglądarce przejść
        window.location.href = "/#" + targetId;
      }
    });
  };

  /**
   * Sticky header – zadanie 3
   * Nagłówek ma top = -(wysokość górnego paska), żeby po przescrollowaniu
   * górny pasek (mail/telefon) chował się, a pasek główny pozostawał w całości
   * widoczny. Wysokość mierzymy na żywo (ResizeObserver), bo zależy od
   * breakpointu / zawijania treści – sztywna wartość ucinała górę paska.
   */
  const initStickyHeader = (header) => {
    const topbar = header.querySelector(".site-header__topbar");

    const updateTopbarHeight = () => {
      const height = topbar ? Math.round(topbar.getBoundingClientRect().height) : 0;
      header.style.setProperty("--site-header-topbar-height", height + "px");
    };

    updateTopbarHeight();

    if (topbar && typeof ResizeObserver !== "undefined") {
      new ResizeObserver(updateTopbarHeight).observe(topbar);
    } else {
      window.addEventListener("resize", updateTopbarHeight);
    }

    let ticking = false;
    const updateScrolledState = () => {
      const threshold = topbar ? topbar.getBoundingClientRect().height : 0;
      header.classList.toggle("is-scrolled", window.scrollY > threshold);
      ticking = false;
    };

    window.addEventListener(
      "scroll",
      () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateScrolledState);
      },
      { passive: true },
    );

    updateScrolledState();
  };

  const initSiteHeader = () => {
    const header = document.querySelector(".site-header");
    if (!header) return;

    initStickyHeader(header);

    const mobileToggle = header.querySelector(".site-header__mobile-toggle");
    const nav = header.querySelector(".site-header__nav");
    if (!mobileToggle || !nav) return;

    const mobileMenu = createMobileMenu(nav, header);
    const closeButton = mobileMenu.querySelector(".site-header__mobile-close");

    mobileToggle.addEventListener("click", () => {
      const isExpanded = mobileToggle.getAttribute("aria-expanded") === "true";

      mobileToggle.setAttribute("aria-expanded", String(!isExpanded));
      mobileMenu.classList.toggle("is-open");
      header.classList.toggle("is-open");
      document.body.style.overflow = !isExpanded ? "hidden" : "";
      document.documentElement.style.overflow = !isExpanded ? "hidden" : "";

      if (!isExpanded && closeButton) {
        closeButton.focus({ preventScroll: true });
      }
    });

    if (closeButton) {
      closeButton.addEventListener("click", () => {
        closeMobileMenu(mobileToggle, mobileMenu, header);
      });
    }

    handleMobileSubmenus(mobileMenu);

    // Anchor links - event delegation na document, obsługuje też clonowane linki
    handleAnchorLinks(mobileToggle, mobileMenu, header);

    // Próg musi odpowiadać breakpointowi xl z _mixins.scss (nawigacja desktopowa)
    window.addEventListener("resize", () => {
      if (window.innerWidth >= 1200) {
        closeMobileMenu(mobileToggle, mobileMenu, header);
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && mobileMenu.classList.contains("is-open")) {
        closeMobileMenu(mobileToggle, mobileMenu, header);
      }
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSiteHeader);
  } else {
    initSiteHeader();
  }
})();
